import jobDemand from './job-demand'
import pub from './public'

export default {
    jobDemand,
    pub
}



// WEBPACK FOOTER //
// ./src/api/project/job/index.js